import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en", // Cambia a "es" si prefieres que el fallback sea español
    debug: false, // 🔴 Desactiva debug si ya no necesitas logs en consola
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"], // Primero busca en localStorage, luego en el navegador
      caches: ["localStorage"], // Guarda el idioma en localStorage
    },
    resources: {
      en: { translation: require("./locales/en.json") },
      es: { translation: require("./locales/es.json") },
    },
  });

export default i18n;
